export default __webpack_public_path__ + "static/media/avatar_3.059f1cd0.png";